import React from 'react';
import { Box, Typography } from '@mui/material';
import { STORY_UI } from '../../solution-stories/storyUiTokens';
import { SEARCE_COLORS } from '../../../theme';
import { formatUsdCompact, type AccountMoverRow } from '../../../utils/billingReportMetrics';

export interface BillingReportTopMoversProps {
  title: string;
  rows: AccountMoverRow[];
  color: string;
  emptyMessage: string;
}

export function BillingReportTopMovers({
  title,
  rows,
  color,
  emptyMessage,
}: BillingReportTopMoversProps): React.ReactElement {
  const maxAmount = Math.max(1, ...rows.map((r) => r.amountUsd));

  return (
    <Box>
      <Typography
        sx={{
          fontFamily: STORY_UI.fontSans,
          fontSize: '12px',
          fontWeight: 600,
          color: STORY_UI.inkFaint,
          textTransform: 'uppercase',
          letterSpacing: '0.03em',
          mb: 1.25,
        }}
      >
        {title}
      </Typography>
      {rows.length === 0 ? (
        <Typography sx={{ fontFamily: STORY_UI.fontSans, fontSize: '13px', color: STORY_UI.inkFaint, py: 2 }}>
          {emptyMessage}
        </Typography>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
          {rows.map((r) => (
            <Box key={r.accountId}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                <Typography
                  sx={{
                    fontFamily: STORY_UI.fontSans,
                    fontSize: '13px',
                    fontWeight: 500,
                    color: STORY_UI.ink,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    maxWidth: 180,
                  }}
                  title={r.accountName}
                >
                  {r.accountName}
                </Typography>
                <Typography sx={{ fontFamily: STORY_UI.fontMono, fontSize: '13px', fontWeight: 600, color }}>
                  {formatUsdCompact(r.amountUsd)}
                </Typography>
              </Box>
              <Box sx={{ height: 6, borderRadius: 3, backgroundColor: STORY_UI.surfaceSunken, overflow: 'hidden' }}>
                <Box
                  sx={{
                    height: '100%',
                    width: `${(r.amountUsd / maxAmount) * 100}%`,
                    backgroundColor: color,
                    borderRadius: 3,
                  }}
                />
              </Box>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}

export const TOP_SAVINGS_COLOR = SEARCE_COLORS.successDark;
export const TOP_OVERSPEND_COLOR = SEARCE_COLORS.errorDark;
